import React from "react";
import styles from "./banco.module.css";
import DOMPurify from "dompurify";

const Banco = ({ icono, url, descripcion }) => {
    const redirigir = () => {
        let urlSalida = 'https://' + url
        //window.location.replace(urlSalida)
        window.open(urlSalida, "_blank");
    }

    return (
        <div className={styles.container}>
            <div className={styles.icono}>
                <img alt="entidad" src={icono} className={styles.img_icono} />
            </div>

            <div className={styles.url}>
                <label className={styles.label_url} onClick={() => redirigir()}>
                    {url}
                </label>
            </div>

            <div className={styles.descripcion}>
                <label dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(descripcion) }} />
            </div>
        </div>
    )
}

export default Banco;